<template>
  <div>
    <v-expansion-panel-header color="accent" class="subtitle-1">
      {{ title }}
    </v-expansion-panel-header>
    <v-expansion-panel-content eager>
      <!-- <v-card tile>
        <v-card-title class="subtitle-1 accent" primary-title>
          <div>{{ title }}</div>
        </v-card-title>
        <v-card-text> -->
      <v-row class="mt-3">
        <v-col>
          <div v-for="(element, i) in formattedConfig" :key="i">
            <Composition
              :title="element.name"
              :values="element.values"
              :required="element.required"
              ref="composition"
              :dialogTitle="dialogTitle"
              :materials="materials"
            ></Composition>
          </div>
        </v-col>
      </v-row>
      <!-- </v-card-text>
      </v-card> -->
    </v-expansion-panel-content>
  </div>
</template>

<script>
import Composition from "./Composition.vue";
export default {
  name: "CompositionFields",
  components: { Composition },
  props: {
    title: String,
    values: Object,
    config: Array,
    fillDynamic: Boolean,
    category: String,
    dialogTitle: String,
  },
  data: () => ({
    materials: [],
  }),
  computed: {
    //add values if any to config by composition name
    formattedConfig() {
      let values = this.config;
      values.map((el) => {
        el["values"] = [];
        if (this.values) {
          for (let [key, value] of Object.entries(this.values)) {
            if (key == el.name) {
              el.values.push(...value);
            }
          }
        }
      });

      //if category includes footwear, remove default material composition fields
      if (this.category.includes("Footwear")) {
        values = values.filter((el) => {
          return el.name != "Material";
        });
      }
      return values;
    },
  },
  async mounted() {
    await this.getMaterials();
  },
  methods: {
    async getMaterials() {
      try {
        const response = await this.$store.dispatch("getDropdowns");
        this.materials = response.data.material;
      } catch (error) {
        console.log(error);
      }
    },
    //creates an array with 'bad' and 'good' string to know if all compositions are valid
    compositionValidation() {
      let validations = [];
      for (let i = 0; i < this.$refs.composition.length; i++) {
        validations.push(this.$refs.composition[i].validateFields());
      }
      //if there are any failed validation
      if (validations.includes("bad")) {
        return false;
      }
      return true;
    },
    //pushes all composition values to an array
    getCompositionData() {
      let values = [];
      for (let i = 0; i < this.$refs.composition.length; i++) {
        if (this.$refs.composition[i].getData() != null) {
          values.push(this.$refs.composition[i].getData());
        }
      }
      return values;
    },
  },
};
</script>